import Vue from 'vue';
import Component from 'vue-class-component';
import {DownloadHelper} from '../../../../helpers/download';
import {Watch} from 'vue-property-decorator';
import {DataManager, Visualisation, Toolbar, Chart, FilterBar, CustomDynamicView} from 'wc-visualisation';
import {Table, Icon, FieldType, Popover, pivotData} from 'wc-lib';
import {format} from 'date-fns';

require('wc-lib/icons/electricity.svg');
require('wc-lib/icons/table.svg');
require('wc-lib/icons/download.svg');
require('wc-lib/icons/graph.svg');
require('wc-lib/icons/infocircle.svg');

@Component({
  template: require('./interconnector-capacity.html'),
  name: 'interconnector-capacity',
  components: {
    'vis-visualisation': Visualisation,
    'vis-toolbar': Toolbar,
    'wc-icon': Icon,
    'vis-table': Table,
    'vis-chart': Chart,
    'vis-filter-bar': FilterBar,
    'wc-popover': Popover
  }
})
export class InterconnectorCapacity extends Vue {
  data: Array<any> = [];
  dynamicView: CustomDynamicView<any>;
  pivotedData: Array<any> = [];
  chartVisible = true;
  tableVisible = false;
  availableInterconnectors: string[] = [];
  selectedInterconnector: string = '';
  infoText: string = 'This chart shows the average import and export limit each day and the MW flow over the period of maximum operational demand net of intermittent generation for each NEM interconnector. The MW flow value represents the median flow observed across all simulations for this period.';
  runDateTime: string = "";
  runNo: string = "";
  id: string;
  columns: Array<any> = [
    { title: 'Interconnector', field: 'INTERCONNECTORID' }, 
    { title: 'Day', field: 'DAY', fieldType: FieldType.DateTime }, 
    { title: 'Export Limit', field: 'CALCULATEDEXPORTLIMIT' }, 
    { title: 'Import Limit', field: 'CALCULATEDIMPORTLIMIT' }, 
    { title: 'MW Flow', field: 'FLOW50' } 
  ];

  get chartButtonType(): string {
    return this.chartVisible ? 'primary' : 'ghost';
  }

  get tableButtonType(): string {
    return this.tableVisible ? 'primary' : 'ghost';
  }

  chartConfig: any = {
    type: 'serial',
    theme: 'simpleblue',
    valueAxes: [{
      id: 'v1',
      position: 'left',
      title: 'MW',
      labelsEnabled: true
    }],
    graphs: [
      { valueAxis: 'v1', balloonText: '[[title]] : [[value]] MWh', title: 'Export Limit', lineThickness:3, valueField: 'CALCULATEDEXPORTLIMIT' }, 
      { valueAxis: 'v1', balloonText: '[[title]] : [[value]] MWh', title: 'Import Limit', lineThickness:3, valueField: 'CALCULATEDIMPORTLIMIT' },
      { valueAxis: 'v1', balloonText: '[[title]] : [[value]] MWh', title: 'MW Flow', lineThickness:3, valueField: 'FLOW50' }
    ],
    chartCursor: {
      categoryBalloonEnabled: true,
      categoryBalloonFunction: function(value) {
        return format(value, 'dd/MM/yyyy');
      },
      cursorAlpha: 1,
      zoomable: false
    },
    categoryAxis: {
      title: 'Date',
      parseDates: true,
      //labelRotation: 45,
      color: '#6F7072',
      gridAlpha: 0.5,
      autoGridCount: true,
      minPeriod: 'hh'
    },
    chartScrollbar: {
        autoGridCount: true,
        graph: 'g1',
        scrollbarHeight: 40,
        oppositeAxis: false
    },
    legend: {
      equalWidths: true,
      useGraphSettings: false,
      position: 'top',
      valueAlign: 'left'
    },
    categoryField: 'DAY'
  }

  applyFilter() {
    this.dynamicView.removeFilters();
    this.dynamicView.applyFind({ 'INTERCONNECTORID': this.selectedInterconnector });
    
    this.data = this.dynamicView.data();
  }

  async created() {
    this.id = await DataManager.addEndPoint('../../api/report/MTPASA_CHART_5', undefined, undefined, 'MTPASA_CHART_5', undefined, 'yyyy-MM-ddTHH:mm:ss', ['RUN_DATETIME', 'DAY']);
    this.dynamicView = DataManager.getDynamicView(this.id, 'interconnector-capacity');
    this.dynamicView.removeFilters();
    let allData = this.dynamicView.data();
    this.runDateTime = format(allData[0].RUN_DATETIME, 'yyyy-MM-dd HH:mm:ss');
    this.runNo = allData[0].RUN_NO;
    allData.forEach( x => {
      if(this.availableInterconnectors.indexOf(x.INTERCONNECTORID) === -1) {
        this.availableInterconnectors.push(x.INTERCONNECTORID);
      }
      this.selectedInterconnector = x.INTERCONNECTORID;
    });

    this.applyFilter();
  }

  @Watch('selectedInterconnector')
  onSelectedInterconnectorChange(newValue: string, oldValue: string) {
    this.applyFilter();
  }

  chartClick() {
    this.chartVisible = true;
    this.tableVisible = false;
  }

  tableClick() {
    this.tableVisible = true;
    this.chartVisible = false;
  }

  downloadClick() {
    DownloadHelper.download('MTPASA_CHART_5', this.data, this.columns);
  }
}



// WEBPACK FOOTER //
// src/views/electricity/nem/mtpasa/interconnector-capacity.ts